import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  siteLoader: false,
  token: "",
  isAuthenticated: false,
  profileData: {},
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    handleSiteLoader: (state, action) => ({
      ...state,
      siteLoader: action.payload,
    }),
    setToken: (state, action) => ({
      ...state,
      token: action.payload,
      isAuthenticated: true,
    }),
    setProfileData: (state, action) => ({
      ...state,
      profileData: action.payload,
    }),
  },
});

export const { handleSiteLoader, setToken, setProfileData } = authSlice.actions;
export default authSlice;
